export function correctItemSize(el, dimension) {
    return Math.round(el.getBoundingClientRect()[dimension]);
}
